import { useStore } from "../../../hooks/use-store";
import { Fragment, useCallback, useEffect } from "react";
import { useRequest } from "ahooks";
// import { PipelineData } from "./Pipeline";
import { observer } from "mobx-react";
import { InternalQueueItem } from "./InternalQueueItem";
import { PipelineData } from "./Pipeline";

const InternalQueue = () => {

    const {
        dataStore: { appStore, spaceStore },
    } = useStore();

    const { runAsync } = useRequest(
        async () =>
            appStore.getPipelines(0),
        {
            loadingDelay: 0,
            manual: true,
            onSuccess: (model) => { },
        }
    );

    const fetchData = useCallback(async () => {
        const res: {
            data: PipelineData
            status: 'pending' | 'completed' | 'ending' | 'failed';
        }[] = await runAsync();

        console.log('res', res)
        spaceStore.setPipelines(
            res.map((r) => ({
                record_id: r.record_id, 
                data: r.data,
                status: r.status
            })).sort((a, b) => a.data.createdAt > b.data.createdAt ? -1 : 1)
        );
    }, [runAsync, spaceStore]);
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return <>
        {spaceStore.pipelines
            .map((pipeline, index) => (
                <Fragment key={pipeline.data.jobId}>
                    <InternalQueueItem
                        pipeline={pipeline.data}
                        status={pipeline.status}
                        update={(pp, status) => {
                            spaceStore.updatePipeline({
                                data: pp,
                                status: status,
                            }, pipeline.data.jobId)
                        }}
                    />
                </Fragment>

            ))}
    </>
}

export default observer(InternalQueue);